module.exports = ".cs-dialog-content mat-select {\r\n\twidth: 100%;\r\n}\r\n\r\n.cs-dialog-content mat-form-field {\r\n\twidth: 100%;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/calibrations/customer-status-dialog/customer-status-dialog.component.css
// module id = ./src/app/calibrations/customer-status-dialog/customer-status-dialog.component.css
// module chunks = main